import { StatusCodes } from 'http-status-codes';
import { createLogger } from '../logger';


const fileLabel = 'HTTP.ts';
const logger = createLogger({
  fileLabel,
});

export const Http = {
  Request: async <A>(methodType: string, url: string, additionalHeaders?: Record<string, string>, payload?: unknown): Promise<A> => {
    let BaseUrl = '';

    if (process.env.NODE_ENV === 'development' && process.env.NX_APP_USE_LOCAL === 'true') {
      if (url.startsWith('/workspace')) BaseUrl = 'http://localhost:8035';
      if (url.startsWith('/hotlines')) BaseUrl = 'http://localhost:8038';
      if (url.startsWith('/helprooms')) BaseUrl = 'http://localhost:8037';
      if (url.startsWith('/resources')) BaseUrl = 'http://localhost:8034';
    } else {
      BaseUrl = process.env.NX_API_URL || '';
    }

    let headers = {
      'content-type': 'application/json',
    };

    if (additionalHeaders) {
      headers = {
        ...headers,
        ...additionalHeaders,
      };
    }

    return new Promise((resolve, reject) => {
      fetch(`${BaseUrl}${url}`, {
        body: JSON.stringify(payload),
        cache: 'no-cache',
        headers,
        method: `${methodType}`,
      })
        .then(async (response: { status: StatusCodes; json: () => Promise<any>; }) => {
          if (response.status === StatusCodes.OK) {
            return response.json().then(resolve);
          }
          return response.json().then(reject);
        })
        .catch((e: any) => {
          logger.error('Error While Calling >', e);
          reject(e);
        });
    });
  },
  AwsWafIntegrationRequest: async <A>(methodType: string, url: string, additionalHeaders?: Record<string, string>, payload?: unknown): Promise<A> => {
    let BaseUrl = '';

    if (process.env.NODE_ENV === 'development' && process.env.NX_APP_USE_LOCAL === 'true') {
      if (url.startsWith('/workspace')) BaseUrl = 'http://localhost:8035';
      if (url.startsWith('/hotlines')) BaseUrl = 'http://localhost:8038';
      if (url.startsWith('/helprooms')) BaseUrl = 'http://localhost:8037';
      if (url.startsWith('/resources')) BaseUrl = 'http://localhost:8034';
    } else {
      BaseUrl = process.env.NX_API_URL || '';
    }

    let headers = {
      'content-type': 'application/json',
    };

    if (additionalHeaders) {
      headers = {
        ...headers,
        ...additionalHeaders,
      };
    }

    return new Promise((resolve, reject) => {
      (window as any).AwsWafIntegration.fetch(`${BaseUrl}${url}`, {
        body: JSON.stringify(payload),
        cache: 'no-cache',
        headers,
        method: `${methodType}`,
      })
        .then(async (response: { status: StatusCodes; json: () => Promise<any>; }) => {
          if (response.status === StatusCodes.OK) {
            return response.json().then(resolve);
          }
          return response.json().then(reject);
        })
        .catch((e: any) => {
          logger.error('Error While Calling >', e);
          reject(e);
        });
    });
  },
  
};
